<script>
  export default {
    name: 'policia-civil'
  }
</script>

<template>
  <router-view></router-view>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// Main.vue?39769196